// extracted by mini-css-extract-plugin
export var closeButton = "_nk-1";
export var closeX = "_nk-3";
export var container = "_nk-0";
export var image = "_nk-2";